<div class="bc-page">

  <!-- ============================================================
       HERO
       ============================================================ -->
  <section class="bc-hero">
    <div class="bc-hero-orb bc-orb-cyan"></div>
    <div class="bc-hero-orb bc-orb-gold"></div>

    <div class="bc-container">
      <div class="bc-hero-grid">

        <div class="bc-hero-left bc-reveal bc-hidden">

          <h1 class="bc-hero-title">11+ Summer Bootcamp</h1>

          <p class="bc-hero-sub">Subject-specific revision across four 11+ subjects — eight focused days each, built around the exam boards that matter.</p>

          <div class="bc-price-row">
            <span class="bc-price-label">As Low As</span>
            <span class="bc-price-badge">£9.50<span class="bc-price-unit">/session*</span></span>
          </div>

          <div class="bc-boards-row">
            <span class="bc-board-chip">CSSE</span>
            <span class="bc-board-chip">GL</span>
            <span class="bc-board-chip">FSCE</span>
            <span class="bc-board-chip">SET</span>
            <span class="bc-board-chip">ISEB</span>
            <span class="bc-board-date"><i class="ti ti-calendar-event"></i>From 19 July</span>
          </div>

          <div class="bc-hero-actions">
            <button class="bc-btn-book" (click)="scrollToBook()">
              Book Your Place
              <i class="ti ti-arrow-right"></i>
            </button>
            <button class="bc-btn-ghost" (click)="downloadBrochure()">
              Download Brochure
              <i class="ti ti-download"></i>
            </button>
          </div>

          <p class="bc-hero-note"><b>Early bird pricing</b> — ends the moment places fill up</p>
        </div>

        <!-- Right: photo with floating price + rating badges -->
        <div class="bc-hero-right bc-reveal bc-hidden bc-d1">
          <div class="bc-hero-photo-wrap">
            <img src="https://images.pexels.com/photos/5212324/pexels-photo-5212324.jpeg" alt="Student preparing for the 11+ Summer Bootcamp" class="bc-hero-photo">

            <div class="bc-hero-price-circle">
              <span class="bc-circle-label">As Low As</span>
              <span class="bc-circle-price">£9.50</span>
              <span class="bc-circle-unit">session*</span>
            </div>

            <div class="bc-hero-float-card">
              <div class="bc-hero-float-stars">
                <i class="ti ti-star-filled"></i><i class="ti ti-star-filled"></i><i class="ti ti-star-filled"></i><i class="ti ti-star-filled"></i><i class="ti ti-star-filled"></i>
              </div>
              <b>10,000+</b>
              <span>families guided</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       STATS
       ============================================================ -->
  <div class="bc-stats-wrap">
    <div class="bc-container">
      <div class="bc-stats-bar bc-reveal bc-hidden">
        <div class="bc-stat" *ngFor="let s of stats">
          <span class="bc-stat-num">{{ s.num }}</span>
          <span class="bc-stat-label">{{ s.label }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================
       SUBJECTS
       ============================================================ -->
  <section class="bc-section bc-subjects-section">
    <div class="bc-container">

      <div class="bc-section-header bc-reveal bc-hidden">
        <p class="bc-eyebrow">What you'll study</p>
        <h2 class="bc-section-title">Four subjects. <em>One method.</em></h2>
        <p class="bc-section-sub">Each subject gets its own 8-day block — deep, focused, and paced for real exam recall.</p>
      </div>

      <div class="bc-subjects-grid">
        <div class="bc-subject-card bc-reveal bc-hidden" *ngFor="let sub of subjects; let i = index" [class]="'bc-d' + (i % 4)">
          <div class="bc-subject-badge" [ngClass]="sub.badgeClass">
            <i class="ti" [ngClass]="sub.icon"></i>
          </div>
          <div class="bc-subject-body">
            <div class="bc-subject-top">
              <span class="bc-subject-name">{{ sub.name }}</span>
              <span class="bc-subject-sessions">{{ sub.sessions }}</span>
            </div>
            <p class="bc-subject-desc">{{ sub.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       HIGHLIGHTS — bento
       ============================================================ -->
  <section class="bc-section bc-highlights-section">
    <div class="bc-container">

      <div class="bc-section-header bc-center bc-reveal bc-hidden">
        <p class="bc-eyebrow">Course highlights</p>
        <h2 class="bc-section-title">Everything <span class="bc-gold">included</span></h2>
      </div>

      <div class="bc-bento">
        <div class="bc-bento-item bc-reveal bc-hidden" [ngClass]="[item.span, 'bc-d' + (i % 4)]" *ngFor="let item of bentoItems; let i = index">
          <div class="bc-bi-icon" [ngClass]="item.iconClass">
            <i class="ti" [ngClass]="item.icon"></i>
          </div>
          <ng-container *ngIf="item.span !== 'bc-bi-6'; else wideItem">
            <div class="bc-bento-num">{{ item.num }}</div>
            <div class="bc-bento-title">{{ item.title }}</div>
            <p class="bc-bento-text">{{ item.text }}</p>
          </ng-container>
          <ng-template #wideItem>
            <div class="bc-bi-6-body">
              <div class="bc-bento-num bc-bi-6-num">{{ item.num }}</div>
              <p class="bc-bento-text">{{ item.text }}</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </section>

  <!-- ============================================================
       FEATURES
       ============================================================ -->
  <section class="bc-section bc-features-section">
    <div class="bc-container">
      <div class="bc-features-inner">

        <div class="bc-features-left bc-reveal bc-hidden">
          <p class="bc-eyebrow">Full package</p>
          <h2 class="bc-section-title">Supportive <em>every step.</em></h2>
          <p class="bc-section-sub">Our Customer Success Team is with you from booking through to results day.</p>
          <div style="margin-top:28px">
            <button class="bc-btn-primary" (click)="scrollToBook()">
              Book Your Place Now
              <i class="ti ti-arrow-right"></i>
            </button>
          </div>
        </div>

        <div class="bc-features-right">
          <div class="bc-feature-item bc-reveal bc-hidden" [class]="'bc-d' + (i % 4)" *ngFor="let f of features; let i = index">
            <div class="bc-feature-icon"><i class="ti" [ngClass]="f.icon"></i></div>
            <div>
              <div class="bc-feature-title">{{ f.title }}</div>
              <p class="bc-feature-text">{{ f.text }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       TESTIMONIAL
       ============================================================ -->
  <section class="bc-section bc-testi-section">
    <div class="bc-container">
      <div class="bc-testi-inner">

        <div class="bc-testi-card bc-reveal bc-hidden">
          <div class="bc-stars">
            <i class="ti ti-star-filled" *ngFor="let s of [1,2,3,4,5]"></i>
          </div>
          <p class="bc-testi-text">The mock tests helped us identify exactly which areas needed work. The result analysis gave us a clear picture week by week — my son secured his place at his chosen grammar school!</p>
          <div class="bc-testi-name">Jaya Rani</div>
        </div>

        <div class="bc-testi-right bc-reveal bc-hidden bc-d1">
          <h2 class="bc-testi-heading">Join <span class="bc-cyan-t">10,000+</span><br>successful <span class="bc-gold-t">students.</span></h2>
          <p class="bc-testi-sub">Sehyog has been guiding students to grammar school success since 2014. Our Bootcamp is rated 5 stars on Trustpilot.</p>
          <button class="bc-btn-book" (click)="scrollToBook()">
            Book Bootcamp Now
            <i class="ti ti-arrow-right"></i>
          </button>
          <div><a class="bc-compare-link" [routerLink]="['/rapid-course']">Compare with Summer Intensive Course <i class="ti ti-arrow-narrow-right"></i></a></div>
        </div>

      </div>
    </div>
  </section>

</div>